<form [formGroup]="form">
  <ng-container formGroupName="BasicConstraints">
    <ix-checkbox
      formControlName="enabled"
      [label]="'Basic Constraints' | translate"
      [tooltip]="helptext.add.basic_constraints.enabled.tooltip | translate"
    ></ix-checkbox>

    <ng-container *ngIf="hasExtension('BasicConstraints')">
      <ix-input
        formControlName="path_length"
        type="number"
        [label]="'Path Length' | translate"
        [tooltip]="helptext.add.basic_constraints.path_length.tooltip | translate"
      ></ix-input>
      <ix-select
        formControlName="BasicConstraints"
        [label]="'Basic Constraints Config' | translate"
        [tooltip]="helptext.add.basic_constraints.config.tooltip | translate"
        [options]="basicConstraintsOptions$"
        [multiple]="true"
      ></ix-select>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="hasAuthorityKeyIdentifier" formGroupName="AuthorityKeyIdentifier">
    <ix-checkbox
      formControlName="enabled"
      [label]="'Authority Key Identifier' | translate"
      [tooltip]="helptext.add.authority_key_identifier.enabled.tooltip | translate"
    ></ix-checkbox>

    <ix-select
      *ngIf="hasExtension('AuthorityKeyIdentifier')"
      formControlName="AuthorityKeyIdentifier"
      [label]="'Authority Key Config' | translate"
      [tooltip]="helptext.add.authority_key_identifier.config.tooltip | translate"
      [options]="authorityKeyIdentifierOptions$"
      [multiple]="true"
    ></ix-select>
  </ng-container>

  <ng-container formGroupName="ExtendedKeyUsage">
    <ix-checkbox
      formControlName="enabled"
      [label]="'Extended Key Usage' | translate"
      [tooltip]="helptext.add.extended_key_usage.enabled.tooltip | translate"
    ></ix-checkbox>

    <ng-container *ngIf="hasExtension('ExtendedKeyUsage')">
      <ix-select
        formControlName="usages"
        [label]="'Usages' | translate"
        [multiple]="true"
        [required]="true"
        [options]="extendedKeyUsageOptions$"
        [tooltip]="helptext.add.extended_key_usage.usages.tooltip | translate"
      ></ix-select>

      <ix-checkbox
        formControlName="extension_critical"
        [label]="'Critical Extension' | translate"
        [tooltip]="helptext.add.extended_key_usage.extension_critical.tooltip | translate"
      ></ix-checkbox>
    </ng-container>
  </ng-container>

  <ng-container formGroupName="KeyUsage">
    <ix-checkbox
      formControlName="enabled"
      [label]="'Key Usage' | translate"
      [tooltip]="helptext.add.key_usage.enabled.tooltip | translate"
    ></ix-checkbox>

    <ix-select
      *ngIf="hasExtension('KeyUsage')"
      formControlName="KeyUsage"
      [label]="'Key Usage Config' | translate"
      [multiple]="true"
      [options]="keyUsageOptions$"
      [tooltip]="helptext.add.key_usage.config.tooltip | translate"
    ></ix-select>
  </ng-container>

  <ix-form-actions>
    <button
      mat-button
      matStepperPrevious
      ixTest="back"
    >{{ 'Back' | translate }}</button>
    <button
      mat-button
      matStepperNext
      color="primary"
      ixTest="next"
      [disabled]="form.invalid"
    >{{ 'Next' | translate }}</button>
  </ix-form-actions>
</form>
